// extracted by mini-css-extract-plugin
export default {"modal":"Modal_modal__7a+Ed","backdrop":"Modal_backdrop__0SWuR","dialog":"Modal_dialog__W1CDL","card":"Modal_card__KI9f4"};